<h1 mat-dialog-title class="!mr-10 text-left">{{ titleText }}</h1>

<mat-dialog-content>
  <p class="w-[30rem] !text-base">{{ bodyText }}</p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)="close(true)">Close</button>
</mat-dialog-actions>
